<template>
  <div class="no-data">暂无数据</div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.no-data {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
</style>
